import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { useMemo, useState, useEffect } from "react";
import msalConfig from "./config/msal-config";
import { Loader } from "./components/loader";
import App from "./App";
import { Login } from "./pages/login";

function AppShell() {
  const [isMsalInitialized, setIsMsalInitialized] = useState<boolean>(false);

  // Create and memoize a single MSAL instance
  const msalInstance = useMemo(() => new PublicClientApplication(msalConfig), []);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
        setIsMsalInitialized(true);
      } catch (error) {
        console.error("Failed to initialize MSAL:", error);
      }
    };
    initializeMsal();
  }, [msalInstance]);

  if (!isMsalInitialized) {
    return <Loader />;
  }

  return (
    <>
      <MsalProvider instance={msalInstance}>
        <AuthenticatedTemplate>
          <App />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </MsalProvider>
    </>
  );
}

export default AppShell;
